/* Puts a warning banner at the top of charts */
import {clsx} from 'clsx';
import React, {useEffect} from 'react';
import {Popup} from 'semantic-ui-react';

import {recordRumAction} from '../util/datadog/datadogRum';

type PlotWarningType =
  | 'bar-chart-group-limits-exceeded'
  | 'group-subsampling'
  | 'grouped-runs-exceed-max-groups'
  | 'grouped-runs-exceed-max-runs'
  | 'grouped-runs'
  | 'multi-metric'
  | 'number-of-runs-exceed-max-runs'
  | `max-runs-exceeded-${string}`;

type PlotWarningProps = {
  message: string;
  helpText?: string;
  disallowSelect?: boolean;
  type: PlotWarningType;
};

const PlotWarning: React.FC<PlotWarningProps> = React.memo(
  function PlotWarning({message, helpText, disallowSelect, type}) {
    'use memo';

    useEffect(() => {
      recordRumAction('Line_plot_legend_warning', {
        // "type" matches a Datadog standard attribute that will conflict when doing @context.type
        // https://docs.datadoghq.com/standard-attributes/?product=browser
        // oxlint-disable-next-line wandb/dd-event-context-keys
        type,
        warningType: type,
        message,
      });
    }, [type, message]);

    const span = (
      <span
        className={clsx('plot-warning', {
          'select-none': disallowSelect,
        })}>
        {message}
      </span>
    );

    if (helpText == null) {
      return span;
    }

    return (
      <Popup
        inverted
        size="mini"
        position="bottom center"
        content={helpText}
        flowing
        popperModifiers={{
          preventOverflow: {
            // prevent popper from erroneously constraining the popup to the
            // table header
            boundariesElement: 'viewport',
          },
        }}
        trigger={span}
      />
    );
  }
);

export default PlotWarning;
